module.exports = __webpack_public_path__ + "img/078-hail.d4ef62b7.svg";